<!--
 * @Author: wangjiaxiang
 * @Date: 2022-08-10 14:04:02
 * @LastEditTime: 2022-11-16 18:38:08
 * @LastEditors: taoyan taoyan_work@163.com
 * @Description: 宝宝卡片信息
 * @FilePath: /大增长星妈会C端/xmh-front-content/src/components/home/userCard/index.vue
 *
-->
<template>
  <div>
    <!-- 已登陆 -->
    <div class="user-card-wrap" v-if="loginFlag">
      <!-- 已经定制 -->
      <div v-if="editFlag">
        <!-- 备孕中 -->
        <!-- 怀孕中 -->
        <div v-if="currentBabyInfo.tag_id == 2">
          <div class="baby-information">
            <div class="baby-details">
              <p class="baby-name">怀孕中</p>
              <div class="baby-age">
                <p>
                  孕{{ babyMonthList.tagTime }}周 距离预产期还有{{
                    babyMonthList.residueDay
                  }}天
                </p>
                <img @click="editBaby" src="./image/edit_baby.png" alt="" />
              </div>
              <p class="baby-height">
                平均{{ babyMonthList.tagTime > 35 ? "身高" : "身长" }}
                {{ babyHeight }}
              </p>
              <p class="baby-height">平均体重 {{ babyWeight }}</p>
            </div>
            <!-- 宝宝头像 -->
            <div
              v-if="babyMonthList.tagTime"
              class="pregnancy-baby-face"
              :style="{
                backgroundImage:
                  'url(' +
                  require(`./image/${(babyMonthList.tagTime >= 10
                    ? '0'
                    : '00') + babyMonthList.tagTime}.png`) +
                  ')',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
              }"
            ></div>
          </div>
        </div>
        <!-- 月龄 -->
        <div v-if="currentBabyInfo.tag_id > 2">
          <div class="baby-information">
            <div class="baby-details">
              <p class="baby-name">{{ currentBabyInfo.nick || "鹤小宝" }}</p>
              <div class="baby-age">
                <p>{{ currentBabyInfo.birth }} {{ babyMonthList.time }}</p>
                <img @click="editBaby" src="./image/edit_baby.png" alt="" />
              </div>
              <p class="baby-height">
                平均{{ babyMonthList.tagTime > 35 ? "身高" : "身长" }}
                {{ babyHeight }}
              </p>
              <p class="baby-height">平均体重 {{ babyWeight }}</p>
            </div>
            <div class="boreder-white">
              <!-- 宝宝头像 -->
              <div
                @click="currentBabyInfo.pic ? '' : editBaby()"
                class="baby-face"
                :style="{
                  backgroundImage:
                    'url(' +
                    (currentBabyInfo.pic
                      ? currentBabyInfo.pic
                      : require('./image/add_baby.png')) +
                    ')',
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  borderRadius: '50%',
                }"
              ></div>
            </div>
          </div>
        </div>
        <!-- 宝宝变化和资源位 -->
        <div
          class="baby-change"
          :style="currentBabyInfo.tag_id == 1 ? 'margin-top:10px;' : ''"
        >
          <div
            class="baby-change-content"
            @click="currentBabyInfo.tag_id == 1 ? toBaby() : toParenting()"
          >
            <p class="txt-title" v-if="currentBabyInfo.tag_id != 1">宝宝变化</p>
            <p
              :style="currentBabyInfo.tag_id == 1 ? 'width:100%;' : ''"
              class="txt-content"
            >
              {{
                currentBabyInfo.tag_id == 1 ? babyArticle.text : babyChangeText
              }}
            </p>
          </div>
          <div class="advertising-scroll" v-if="cardResourceList.length > 0">
            <my-swiper
              :autoplayNumber="3000"
              :autoplay="cardResourceList.length > 1"
              :loop="cardResourceList.length > 1"
              :swipeid="'advertising_swiper'"
              :slidesNum="1"
              :direction="'vertical'"
              :paginationFlag="false"
              :centeredSlides="true"
              @slideChange="slideChange"
              style="overflow: hidden"
            >
              <div
                class="swiper-slide swiper-no-swiping homdeBabySele"
                v-for="(item, index) in cardResourceList"
                :key="'swiper'+item.id"
                :data="JSON.stringify({id:item.id})"
                :databanner="JSON.stringify({...resourceNiche(item),xmh5_ziyuanwei_position: index+1})"
                @click="handleResource(item,index)"
                slot="swiper-con"
              >
                <div class="type slide-view" :data="JSON.stringify(item)">
                  {{ type(item.promotionType) }}
                </div>
                <p>{{ item.resTitle }}</p>
              </div>
            </my-swiper>

            <template v-for="(item, index) in cardResourceList">
              <div
                class="commodity-link"
                v-if="item.promotionType && activeIndex == index && item.jumpType === 3"
                :key="'comm'+item.id"
              >
                <openWxTag
                  :id="'xmyxItem' + item.id"
                  :path="item.jumpTargetUrl"
                  :appId="item.miniProgramTypeAppId"
                  btnStyle="width:100%;height:36px"
                  @sensorsFn="ResourceBurial(item,index)"
                ></openWxTag>
              </div>
<!--              <div-->
<!--                v-if="item.promotionType != 1 && activeIndex == index"-->
<!--                :key="item.id"-->
<!--                class="not-commodity"-->
<!--                @click="resourceJump(item)"-->
<!--              ></div>-->
            </template>
          </div>
        </div>
      </div>
      <!-- 未定制 -->
      <!-- <div v-else>
        <div class="no-baby-popup">
          <p>点击添加宝宝信息可享定制化育儿服务</p>
          <img src="@/assets/images/baby/share.jpg" alt="" />
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
// 组建
import mySwiper from "@/components/common/mySwiper/mySwiper.vue";
import babyList from "@/utils/mockData/noBabyArticleList.js";
import openWxTag from "@/components/common/openWeappTag/index.vue"; // 打开小程序开放标签
// 数据
import babyBMI from "@/utils/mockData/babyBMI.js";
//  js方法
import {
  BuiedPointClick_Fn,
  Exposurer_Fn,
  xmhziyuanwei_data_expo
} from "@/assets/js/BuriedPointEvent.js";
import { home_resources_content } from "@/assets/js/Exposure";
import { getPageListOnLine } from "@/utils/commonApiList.js";
import { advertisJump,resourceNiche } from "@/assets/js/common"

export default {
  name: "",
  props: [
    "loginFlag",
    "editFlag",
    "UserInfo",
    "currentBabyInfo",
    "babyDays",
    "babyInfo",
  ],
  watch: {
    // 当前宝宝信息
    currentBabyInfo(newVal) {
      if (newVal.tag_id > 1) {
        this.getMonthInfo();
      }
      // 获取资源位
      this.getResourcesData();
    },
  },
  data() {
    return {
      noBabyList: babyList.articleList, // 备孕宝宝文章列表
      babyChangeText: "", // 宝宝变化文案
      babyMonthList: [],
      cardResourceList: [], // 资源位上下轮播数据
      data: babyBMI, //宝宝BMI
      active: null,
      activeIndex: 0,
      babyArticle: []
    };
  },

  components: {
    mySwiper,
    openWxTag,
  },

  computed: {
    // 宝宝的身高
    babyHeight() {
      if (this.babyMonthList.tagTime != null) {
        // 孕期身高
        if (this.currentBabyInfo.tag_id == 2) {
          return this.data.babyPregnancyBMI[this.babyMonthList.tagTime].height;
        } else {
          // 男孩 女孩 身高
          if (this.currentBabyInfo.sex === "M") {
            return this.data.boyBMI[this.babyMonthList.tagTime].height;
          } else {
            return this.data.girlBMI[this.babyMonthList.tagTime].height;
          }
        }
      }
    },
    // 宝宝的体重
    babyWeight() {
      if (this.babyMonthList.tagTime != null) {
        // 孕期身高
        if (this.currentBabyInfo.tag_id == 2) {
          return this.data.babyPregnancyBMI[this.babyMonthList.tagTime].weight;
        } else {
          // 男孩 女孩 体重
          if (this.currentBabyInfo.sex === "M") {
            return this.data.boyBMI[this.babyMonthList.tagTime].weight;
          } else {
            return this.data.girlBMI[this.babyMonthList.tagTime].weight;
          }
        }
      }
    },
  },

  created() {},

  mounted() {

    this.getBabyArticle();
    if (this.currentBabyInfo.tag_id > 1) {
      this.getMonthInfo();
    }
    // 获取资源位
    this.getResourcesData();
    this.$http.get(
      "/wechat/oauth2/getJSSDKConfig?url=" +
        encodeURIComponent(location.href.split("#")[0]),
      {},
      (res) => {
        wx.config({
          debug: false,
          appId: res.appId,
          timestamp: res.timestamp,
          nonceStr: res.nonceStr,
          signature: res.signature,
          jsApiList: ["onMenuShareTimeline"], // 必填，需要使用的JS接口列表
          openTagList: ["wx-open-launch-weapp"], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
        });
        wx.ready(function() {
          console.log("ready");
        });
        wx.error(function(res) {
          console.log("err", res);
        });
      }
    );
  },

  methods: {
    resourceNiche,
    BuiedPointClick_Fn,
    ResourceBurial(item,index){
      sensors.track('xmh5_ziyuanwei_click',{
        ...this.resourceNiche(item),
        xmh5_ziyuanwei_position: index+1,
      })
      BuiedPointClick_Fn(
          'xmhh5_home_oparea1_click',
          this.getBuiedPointObj(item, index)
      )
    },
    //
    handleResource(item,index){
      console.log(item)
      sensors.track('xmh5_ziyuanwei_click',{
        ...resourceNiche(item),
        xmh5_ziyuanwei_position: index+1,
      })
      advertisJump(item,this).then(res=>{
        if(res.jumpType === 5){
          const doctorInfo = {
            ...res,
            contentUrl: res.jumpTargetUrl,
            contentPayUrl: res.jumpTargetUrl,
          }
          this.$emit('babySwiperClick', doctorInfo)
        }
      })
      console.log(item)
    },
    slideClick(value){
      console.log(value)
    },
    slideChange(index) {
      this.activeIndex = index - 1;
      // console.log(this.activeIndex);
      // 当前下标 等于 数组的长度 说明开始第二轮 下标设置为0
      if (this.activeIndex == this.cardResourceList.length) {
        this.activeIndex = 0;
      }
    },
    // 所有月龄信息
    getMonthInfo() {
      if (
        this.currentBabyInfo.birth != "" &&
        this.currentBabyInfo.birth != null
      ) {
        this.$http.get(
          "/babyCareTips/getAllInfo",
          { dayBith: this.currentBabyInfo.birth },
          (res) => {
            if (res.code == "200") {
              this.babyMonthList = res.data;
              console.log(this.babyMonthList);
              var tagTime = res.data.tagTime;
              var len = res.data.babyCareTipsList.length;
              //如果是育儿中并且在三岁以上取最后一个
              if (res.data.stage == 2 && tagTime > 35) {
                this.babyMonthList.tagTime = 40;
                this.active = len - 1;
              } else {
                this.active = tagTime;
              }
              res.data.stage == 1
                ? (this.babyChangeImg = this.babyMonthList.babyCareTipsList[
                    this.active
                  ].fetusSizePic)
                : (this.babyChangeImg = this.babyMonthList.babyCareTipsList[
                    this.active
                  ].homePagePic);
              this.babyChangeText = this.babyMonthList.babyCareTipsList[
                this.active
              ].babyChange;
              console.log(res.data);
              this.$emit("getBabyTips", this.babyMonthList);
            }
          }
        );
      }
    },
    // 获取备孕宝宝文章
    getBabyArticle() {
      var num = Math.floor(Math.random() * 10) + 1;
      this.noBabyList.forEach((item, index) => {
        if (item.id == num) {
          this.babyArticle = item;
        }
      });
    },
    // 获取资源位数据
    getResourcesData() {
      this.cardResourceList = [];
      const params = {
        pageNum: 1,
        pageSize: 5,
        locationType: 5,
      }
      getPageListOnLine(params).then(res => {
        if(res.code == 200){
          this.cardResourceList = res.data.data
          this.$nextTick(()=>{
            xmhziyuanwei_data_expo.observe('xmh5_ziyuanwei_view','.homdeBabySele',false)
          })
          setTimeout(() => {
            home_resources_content.observe(".slide-view", false, {});
          }, 300);
        }
      })
    },
    // 修改宝宝信息
    editBaby() {
      setTimeout(() => {
        location.href = "/member/mine/editBaby?num=" + this.currentBabyInfo.num + "&id=" + this.currentBabyInfo.tag_id + '&source=xmhContent';
      }, 200);
      sensors.track("xmhh5_home_babyinfo_click");
    },
    // 跳转奶娃百科文章
    toBaby() {
      sensors.track("home_beiyun_paper_click");
      setTimeout(() => {
        if (this.$http.hostName === "https://mom.feihe.com") {
          this.$router.push("/baby/detail/" + this.babyArticle.prodId);
        } else {
          this.$router.push("/baby/detail/" + this.babyArticle.prodId);
        }
      }, 200);
    },
    // 跳转育儿贴士
    toParenting() {
      var pathUrl;
      if (this.currentBabyInfo == 2) {
        // 孕期
        pathUrl = "/pregnantTips";
      } else {
        // 出生后
        pathUrl = "/parentingTips";
      }
      var that = this;
      setTimeout(function() {
        that.$router.push({
          path: pathUrl + "?sourceFrom=home",
          query: {
            num: that.currentBabyInfo.num,
            bir: that.currentBabyInfo.birth,
            act: that.active,
          },
        });
      }, 200);
    },
    // 资源位跳转
    resourceJump(item) {
      // 1.商品 2.活动 3.热门 4.链接
      switch (item.promotionType) {
        case 1:
          break;
        default:
          const index = this.cardResourceList.findIndex((ite, index) => {
            return ite.id == item.id;
          });
          this.BuiedPointClick_Fn(
            "xmhh5_home_oparea1_click",
            this.getBuiedPointObj(item, index)
          );
          location.href = item.jumpTargetUrl;
          break;
      }
    },
    // p(link) {
    //   const url = new URL(link);
    //   const paramsStr = url.search.slice(1);
    //   const params = new URLSearchParams(paramsStr);
    //   return params.get("product");
    // },
    getBuiedPointObj(item, index) {
      return {
        xmhh5_home_oparea1_type: this.type(item.promotionType),
        xmhh5_home_oparea1_title: item.resTitle,
        xmhh5_home_oparea1_number: index,
        xmhh5_home_oparea1_url: item.jumpTargetUrl,
        // xmhh5_home_oparea1_goodsname: item.goodsName,
      };
    },
    type(type) {
      return { 1: "商品", 2: "活动", 3: "热门", 4: "链接" }[type];
    },
  },
};
</script>
<style lang="less" scoped>
@import "./less/index.less";
</style>
